import axiosInstance from ".";

export const getTest = async (params) => {
  return axiosInstance.get(`/testimonials`, { params });
};

export const addTest = (data) => {
  return axiosInstance.post("/testimonials", data);
};

export const udpateTest = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/testimonials/${id}`, payload);
};

export const deleteTest = (id) => {
  return axiosInstance.delete(`/testimonials/${id}`);
};

export const getTestById = ({ queryKey }) => {
  const [queries] = queryKey;
  return axiosInstance.get(`/testimonials`, { params: queries });
};
